import React from 'react'
import PropTypes from 'prop-types'
import {PERMISSION_TO_LABEL_MAP} from './SettingsConstants'
import RXRIcon from '../RXRIcon'
import {Colors, Typography as TypographyStyle} from '../../assets/styles'
import {makeStyles} from '@mui/styles'
import {spaceMedium, spaceSmall} from '../../assets/styles/spacing'
import {getPermissionObjectForPermissionGroup} from '../../reducers/groupPermissionsReducer'

function StaffPermissionsList(props) {
  const classes = useStyles()

  const permissionsObject = getPermissionObjectForPermissionGroup(props.userType)

  return (
    <div>
      <div className={classes.permissionsSubTitle}>Permissions</div>

      {Object.entries(PERMISSION_TO_LABEL_MAP).map(([key, label]) => (
        <div key={key} className={classes.permissionItem} style={permissionsObject[key] ? undefined : {textDecoration: 'line-through'}}>
          <RXRIcon
            className={classes.permissionIcon}
            icon={permissionsObject[key] ? RXRIcon.CHECK : RXRIcon.TODO}
            color={Colors.rxrPrimaryColor}
          />
          <span className={classes.permissionLabel}>{label}</span>
        </div>
      ))}
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  permissionsSubTitle: {
    marginTop: spaceMedium,
    fontSize: TypographyStyle.fontSizeSmall,
    color: theme.palette.primary.main,
  },
  permissionItem: {
    marginTop: spaceSmall,
  },
  permissionIcon: {
    marginRight: spaceSmall,
  },
  permissionLabel: {
    fontSize: TypographyStyle.fontSizeMediumLarge,
  },
}))

StaffPermissionsList.propTypes = {
  userType: PropTypes.string.isRequired,
}

export default StaffPermissionsList
